import { type Component, type JSX, splitProps } from "solid-js";
import { cn } from "@stockpilot/shared";

interface GlassSurfaceProps extends JSX.HTMLAttributes<HTMLDivElement> {
  children?: JSX.Element;
  borderEdge?: "teal" | "purple" | "accent" | "none";
  disableBlur?: boolean;
  ref?: (el: HTMLDivElement) => void;
}

export const GlassSurface: Component<GlassSurfaceProps> = (props) => {
  const [local, rest] = splitProps(props, [
    "children",
    "class",
    "borderEdge",
    "disableBlur",
    "style",
  ]);

  const borderClass = () => {
    if (local.borderEdge === "teal") {
      return "border-l-success";
    }
    if (local.borderEdge === "purple" || local.borderEdge === "accent") {
      return "border-l-accent";
    }
    return "border-l-transparent";
  };

  const hasCustomBorder = () => {
    const cls = local.class ?? "";
    return /border-(?:primary|transparent|danger)/.test(cls);
  };

  return (
    <div
      ref={props.ref}
      class={cn(
        "relative overflow-hidden border-[1.5px] bg-[var(--glass)] rounded-[var(--radius-xl)]",
        !hasCustomBorder() && "border-[var(--glass-border)]",
        !local.disableBlur && "backdrop-blur-xl",
        local.class,
      )}
      style={local.style}
      {...rest}
    >
      {/* Top Highlight line */}
      <div
        class="absolute top-0 left-0 right-0 h-[1px] bg-white/10"
        style={{ "background-color": "var(--glass-highlight)" }}
      />

      {/* Border Edge (Optional) */}
      <div
        class={cn("h-full w-full p-px", local.borderEdge !== "none" && "border-l-4", borderClass())}
      >
        {local.children}
      </div>
    </div>
  );
};
